import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import React from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as MenuDots } from "../assets/menuDots.svg";

const TableDropdownMenu = ({ items = [] }) => {
  const { t } = useTranslation();
  return (
    <Menu
      menuButton={
        <MenuButton className="flex items-center justify-center rounded-md bg-gray-100 p-2 dark:bg-gray-800">
          <MenuDots className="h-3 w-3 rotate-90 text-text dark:text-white" />
        </MenuButton>
      }
      transition
      align="end"
      menuClassName="select-none rounded-md p-1 text-sm dark:bg-dark-surface"
    >
      {items.map(({ label, onClick, icon, className }, index) => (
        <MenuItem
          key={index}
          className={`flex items-center gap-2 rounded-lg px-2 py-1 text-[13px] font-medium text-text dark:text-white ${className || ""}`}
          onClick={onClick}
        >
          {icon}
          {t(label)}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default TableDropdownMenu;
